module.exports = __webpack_public_path__ + "static/media/banner-video-bg.0d1be983.png";